import { compareAsc, format, isAfter, parseISO } from "date-fns";

/**
 * Normalize one row from public/manual-events.json
 */
export function normalizeManualEvent(raw, i) {
    if (!raw || typeof raw !== "object") return null;
    const url = typeof raw.url === "string" ? raw.url.trim() : "";
    if (!url) return null;
    return {
        id: raw.id || `manual-${i}`,
        name: raw.name || "Event",
        start_at: raw.start_at || null,
        end_at: raw.end_at || null,
        timezone: raw.timezone || "Africa/Nairobi",
        url,
        cover_url:
            (typeof raw.cover_url === "string" && raw.cover_url.trim()) ||
            (typeof raw.image === "string" && raw.image.trim()) ||
            "",
        description: raw.description || "",
    };
}

export async function fetchManualEventsFromPublic() {
    const base = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
    try {
        const r = await fetch(`${base}/manual-events.json`, {
            cache: "no-store",
        });
        if (!r.ok) return [];
        const data = await r.json();
        if (!Array.isArray(data)) return [];
        return data.map(normalizeManualEvent).filter(Boolean);
    } catch {
        return [];
    }
}

/**
 * Next upcoming session you’re hosting (requires start_at in the future).
 */
export function pickNextHostingEvent(events) {
    if (!events?.length) return null;
    const now = new Date();
    const upcoming = [];
    for (const e of events) {
        if (!e?.start_at) continue;
        try {
            const t = parseISO(e.start_at);
            if (Number.isNaN(t.getTime())) continue;
            if (isAfter(t, now) || t.getTime() === now.getTime()) {
                upcoming.push(e);
            }
        } catch {
            continue;
        }
    }
    upcoming.sort((a, b) =>
        compareAsc(parseISO(a.start_at), parseISO(b.start_at)),
    );
    return upcoming[0] || null;
}

export function formatEventRange(ev) {
    if (!ev.start_at) {
        return "Date & time — see Luma";
    }
    try {
        const start = parseISO(ev.start_at);
        const tz = ev.timezone || "UTC";
        if (ev.end_at) {
            const end = parseISO(ev.end_at);
            return `${format(start, "EEE d MMM yyyy, HH:mm")} – ${format(end, "HH:mm")} (${tz})`;
        }
        return `${format(start, "EEE d MMM yyyy, HH:mm")} (${tz})`;
    } catch {
        return ev.start_at || "Date TBA";
    }
}

export function stripMd(s) {
    if (!s || typeof s !== "string") return "";
    return s
        .replace(/\*\*|__|#/g, "")
        .replace(/\[([^\]]+)\]\([^)]+\)/g, "$1");
}
